var map = {
	"./": [
		514,
		"node_modules_ionicons_dist_esm-es5_index_js"
	],
	"./index": [
		514,
		"node_modules_ionicons_dist_esm-es5_index_js"
	],
	"./index-c73a3717": [
		8041
	],
	"./index-c73a3717.js": [
		8041
	],
	"./index.js": [
		514,
		"node_modules_ionicons_dist_esm-es5_index_js"
	],
	"./ion-icon.entry": [
		7614,
		"node_modules_ionicons_dist_esm-es5_ion-icon_entry_js"
	],
	"./ion-icon.entry.js": [
		7614,
		"node_modules_ionicons_dist_esm-es5_ion-icon_entry_js"
	],
	"./ionicons": [
		8186,
		"node_modules_ionicons_dist_esm-es5_ionicons_js"
	],
	"./ionicons.js": [
		8186,
		"node_modules_ionicons_dist_esm-es5_ionicons_js"
	],
	"./loader": [
		311,
		"node_modules_ionicons_dist_esm-es5_loader_js"
	],
	"./loader.js": [
		311,
		"node_modules_ionicons_dist_esm-es5_loader_js"
	],
	"./utils-aaa0769a": [
		2139
	],
	"./utils-aaa0769a.js": [
		2139
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3918;
module.exports = webpackAsyncContext;